import { Box } from "@mui/material";
import moment from "moment";
import ActionBar from "../../../components/Actionbar/ActionBars";
import Header from "../../../components/Header/Header";
import DashboardTable from "../../../components/Table/DashboardTable";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import "../../../components/dataTable.scss";
import * as pro from "../../../redux/processor/actions";
import { clearApiStatus } from "../../../redux/pre_processor/actions";
import constant from "../../../constants/constantValues";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import { getPendingBatchesList } from "../../../redux/shared/actions";
import PendingFiles from "../../../components/PendingFiles";
import Label from "../../../components/Label/Label";

const ProcessorDashboard = () => {
  const dispatch = useDispatch();
  const [projects, setProjects] = useState([]);
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [list, setList] = useState([]);
  const [openFileStatusDialog, setOpenFileStatusDialog] = useState(false);

  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  // const [proView, setProView] = useState([]);
  const [severity, setSeverity] = useState("");
  const fromState = useSelector((state) => state?.pro?.proProjects);
  const type = useSelector((state) => state?.pro?.type);
  // let projectFromState = fromState?.data?.processor_projects
  //   ? fromState?.data?.processor_projects
  //   : [];
  const pendinBatchesList = useSelector(
    (state) => state?.shared?.pendinBatchesList
  );

  const {
    // PROJECT_HEADER,
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    END_DATE,
    ASSIGNED,
    OCR_STATUS,
    LAST_UPDATED,
    ACTION,
  } = constant;

  useEffect(() => {
    // if (projectFromState?.length > 0) {
    setProjects(fromState?.data);
    // }
  }, [type]);

  useEffect(() => {
    // if (fromState?.data?.length > 0) {
    setProjects(fromState?.data);
    // }
  }, [fromState?.data]);

  useEffect(() => {
    if (apiStatus?.apiError) {
      setMessage(apiStatus.message);
      setSeverity("error");
      setNotification(true);
    }
  }, [apiStatus]);

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(
      pro.getProcessorList({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
    dispatch(getPendingBatchesList({}));
  }, [dispatch]);

  useEffect(() => {
    const baseURL = process.env.REACT_APP_APIBASE_WS;
    const newSocket = new WebSocket(
      `${baseURL}/auto-extraction-status/?token_header=${localStorage.getItem(
        "token"
      )}`
    );

    newSocket.onopen = () => {};

    newSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const completionID = data?.payload?.Batch_Id;
      const allOtherData = data?.payload;

      if (completionID >= 0) {
        setProjects((prevProjects) =>
          prevProjects.map((project) => {
            const indexToUpdate = project?.batch_info?.findIndex(
              (item) => item.batch_id === completionID
            );

            if (indexToUpdate !== -1) {
              const updatedProject = { ...project };
              updatedProject.batch_info = [...project.batch_info];
              updatedProject.batch_info[indexToUpdate] = {
                ...updatedProject.batch_info[indexToUpdate],
                completion_status: allOtherData?.Completion,
                is_ocr_done: allOtherData?.is_ocr_done,
                ocr_re_initiate: allOtherData?.ocr_re_initiate,
                is_failed: allOtherData?.is_failed,
              };
              return updatedProject;
            }
            return project;
          })
        );
      }
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket error (WebSocket): ", error);
    };

    return () => {
      newSocket.close(); // ✅ cleanup on unmount
    };
  }, []); // ✅ only on mount

  useEffect(() => {
    if (pendinBatchesList?.data?.processor_projects?.length > 0) {
      setList(pendinBatchesList?.data?.processor_projects);
    }
  }, [pendinBatchesList?.data?.processor_projects]);

  const onSearch = (word, type) => {
    let result;
    let filteredProjects = [];

    if (!fromState?.data || !Array.isArray(fromState.data)) {
      setProjects([]);
      return;
    }

    if (type === "project") {
      if (word) {
        result = fromState?.data?.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
      } else {
        result = fromState?.data;
      }
    } else {
      if (word) {
        fromState?.data?.map((item, index) => {
          const filteredBatches = item?.batch_info?.filter(function (el) {
            return (
              el?.batch_name
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) !== -1
            );
          });
          if (filteredBatches.length > 0) {
            filteredProjects.push({
              ...fromState?.data[index],
              batch_info: filteredBatches,
            });
          } else {
          }
        });
        result = filteredProjects;
      } else {
        result = fromState?.data;
      }
    }
    setProjects([...result]);
  };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";

    dispatch(
      pro.getProcessorList({
        type,
        formattedStartDate,
        formattedEndDate,
        status,
      })
    );
  };
  const clear = () => {
    dispatch(
      pro.getProcessorList({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
  };

  let header = [
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    END_DATE,
    ASSIGNED,
    OCR_STATUS,
    LAST_UPDATED,
    ACTION,
  ];

  const onClickViewPendingBatches = () => {
    setOpenFileStatusDialog(true);
  };

  return (
    <>
      <Header />
      <ActionBar
        onSearch={(value, type) => onSearch(value, type)}
        filterByDate={filterByDate}
        clear={clear}
        onClickViewPendingBatches={onClickViewPendingBatches}
        list={list}
      />
      {/* <ProjectHeader text={PROJECT_HEADER} headerColor="white" /> */}
      {fromState?.loader ? (
        <DashboardTableSkaleton />
      ) : projects?.length === 0 ? (
        <div className="no-data">
          <Label
            text="No Data Found"
            fontSize="16"
            fontWeight="600"
            padding="20px"
          />
        </div>
      ) : (
        <Box>
          <DashboardTable
            header={header}
            projects={projects}
            // proView={proView}
          />
        </Box>
      )}
      {notification && (
        <CustomizedSnackbars
          severity={severity}
          state={notification}
          text={message}
          handleClose={() => setNotification(false)}
        />
      )}

      <PendingFiles
        openFileStatusDialog={openFileStatusDialog}
        setOpenFileStatusDialog={setOpenFileStatusDialog}
        list={list}
      />
    </>
  );
};
export default ProcessorDashboard;
